import { Form, Input, Button, message } from "antd";
import React, { useRef, useEffect, useMemo, useState } from "react";
import ModelosTable from "../../modelos/_ModelosTable";
import unwrapAxiosPromise from "../../../util/unwrapAxiosPromise";
import axios from "axios";
import { useTranslation } from "react-i18next";
import ActionBar from "../../../components/action-bar";
import DocxViewer from "../../../components/view-docx";
import { useLocation } from "react-router-dom";

export default function passos(passo, docxBlob, setModeloSelecionado, modeloSelecionado, form) {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const id = queryParams.get("id");
  const path = queryParams.get("path");
  const { t } = useTranslation();
  const miniTableRef = useRef();
  const [loadingRemove, setLoadingRemove] = useState(false);
  const [loadingSearch, setLoadingSearch] = useState(false);
  const [activeSearch, setActiveSearch] = useState();
  const [personalizado, setPersonalizado] = useState(true);
  const [selectedId, setSelectedId] = useState(null);
  const [dataSource, setDataSource] = useState([]);

  const handleSearch = (search, personalizado = false) => {
    setLoadingSearch(true);
    unwrapAxiosPromise(axios.get("/modelos", { params: { search, personalizado, tags: path } }))
      .then((data) => {
        setActiveSearch(search);
        setDataSource(data);
      })
      .finally(() => setLoadingSearch(false));
  };
  const fetchModelosPersonalizado = ({ personalizado }) => {
    setPersonalizado(personalizado);
    handleSearch(activeSearch || "", personalizado);
  };

  const handleSelectedIdChange = (id) => {
    setSelectedId(id);
    const modelo = dataSource.find((m) => m.id === id[0]);
    setModeloSelecionado(modelo || null);
  };
  const title = () => {
    return <ActionBar onSearch={(search) => handleSearch(search, personalizado)} />;
  };

  const visualizarArquivo = (value) => {
    const urlCompleta = value.anexo.url.startsWith("http") ? value.anexo.url : `${window.location.origin}${value.anexo.url}`;
    const googleViewerUrl = `https://docs.google.com/gview?url=${urlCompleta}`;
    window.open(googleViewerUrl, `viewer_${Date.now()}`, "width=1200,height=800,noopener,noreferrer");
  };
  switch (passo) {
    case 1:
      return (
        <>
          <div style={{ marginBottom: "25px" }}>
            <h1 style={{ fontSize: "20px", marginBottom: "4px" }}>{t("Assistente de utilização de Modelos")}</h1>
            <h2 style={{ fontSize: "14px", fontWeight: "normal", color: "#888" }}>{t("Escolha o tipo de modelo que deseja utilizar")}</h2>
          </div>

          <div style={{ flexGrow: 1 }}>
            <ModelosTable
              dataSource={dataSource} // props
              loading={loadingSearch || loadingRemove}
              miniTableRef={miniTableRef}
              onSelectedIdsChange={handleSelectedIdChange}
              selectedIds={selectedId}
              title={title}
              fetchModelosPersonalizado={fetchModelosPersonalizado}
              enableRowSelection={true}
              singleSelection={true}
              personalizado={personalizado}
              setPersonalizado={setPersonalizado}
              onClick={visualizarArquivo}
            />
          </div>
        </>
      );
    case 2:
      return (
        <div>
          {docxBlob ? (
            <DocxViewer blob={docxBlob} />
          ) : (
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                height: "100%",
                color: "#888",
              }}
            >
              Carregando documento...
            </div>
          )}
        </div>
      );
    case 3:
      return (
        <>
          <div style={{ marginBottom: "25px" }}>
            <h1 style={{ fontSize: "20px", marginBottom: "4px" }}>Assistente de utilização de Modelos</h1>
            <h2 style={{ fontSize: "14px", fontWeight: "normal", color: "#888" }}>Preencha o conteúdo dos campos com as informações necessárias do Modelo</h2>
          </div>

          <div>
            <h3
              style={{
                fontSize: "18px",
                fontWeight: "600",
                color: "#333",
                marginBottom: "20px",
              }}
            >
              {t("Campos informativos:")}
            </h3>

            <Form form={form}>
              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: "max-content 300px",
                  gap: "8px 4px",
                  alignItems: "center",
                }}
              >
                {modeloSelecionado.campos.map((campo) => (
                  <React.Fragment key={campo}>
                    <div
                      style={{
                        textAlign: "right",
                        whiteSpace: "nowrap",
                      }}
                    >
                      {`${t(campo)}:`}
                    </div>
                    <Form.Item name={campo} rules={[{ required: true, message: "Campo obrigatório" }]} style={{ marginBottom: 0 }}>
                      <Input placeholder={t(`Digite o valor para ${campo}`)} />
                    </Form.Item>
                  </React.Fragment>
                ))}
              </div>
            </Form>
          </div>
        </>
      );
    case 4:
      return (
        <div>
          {docxBlob ? (
            <DocxViewer blob={docxBlob} style={{ height: "100%", width: "100%" }} />
          ) : (
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                height: "100%",
                color: "#888",
              }}
            >
              Carregando documento...
            </div>
          )}
        </div>
      );
    case 5:
      return (
        <>
          <div style={{ marginBottom: "25px" }}>
            <h1 style={{ fontSize: "20px", marginBottom: "4px" }}>Assistente de utilização de Modelos</h1>
            <h2 style={{ fontSize: "14px", fontWeight: "normal", color: "#888" }}>Dê um nome ao documento gerado antes de finalizar.</h2>
          </div>
          <Form form={form} layout="vertical">
            <Form.Item label="Nome arquivo" name="nameFile" rules={[{ required: true, message: "Insira um nome para o arquivo." }]}>
              <Input placeholder="Ex: Contrato João da Silva" />
            </Form.Item>
          </Form>
        </>
      );
    default:
      return null;
  }
}
